module.exports = __webpack_public_path__ + "img/credit5.6be526cf.png";